import React from "react"
import { Link } from "gatsby"

import "./blogCategories.css"
import "./blogTags.css"
import "./blogShareIcons.css"

export const BlogCategories = ({ postCategories, postCategoryTitles, classname='' }) => (
    <div className={`absolute cat__wrap ${classname}`}>
        <div className="flex flex-col justify-center">
        {postCategories.map((cat, index) => (
            <a href={`/blog/?cat=${cat.title}`} key={index} className="decoration-none cat__item"><span className={`${
                postCategoryTitles.includes(cat.title) ? 'active' : ''
                }`}>{cat.title}</span></a>
        ))}
        </div>
    </div>
)

export const BlogTags = ({ tags, isCenter }) => (
    <div className={`flex blog-tags ${isCenter && 'justify-center'}`}>
        {tags.map((tag, index) => (
            <div key={index} className="text-white">{tag}</div>
        ))}
    </div>
)

export const BlogBackButton = ({ isStyleCustomize=false }) => (
    <div className={`uppercase bp-action__wrap ${isStyleCustomize ? 'bp-action--customize' : 'text-center'}`}>
        <Link to="/blog" className="decoration-none"><span className="icon-plus"></span>Back to Blog</Link>
    </div>
)

export const BlogShareIcons = ({ socialsList, post }) => {
    const baseURl = "https://www.savorbrands.com/blog"
    return (
        <div className="flex blog-social-wrap">
            {socialsList.map((social, index) => (
                <div key={index}>
                    <a
                        href={
                        social.name === 'Facebook'
                            ? `https://www.facebook.com/sharer/sharer.php?u=${baseURl}/${post.blogPostUrlSlug}`
                            : social.name === 'Twitter'
                            ? `https://twitter.com/share?url=${baseURl}/${post.blogPostUrlSlug}&text=${post.title}`
                            : social.name === 'Linkedin'
                            ? `https://www.linkedin.com/shareArticle?url=${baseURl}/${post.blogPostUrlSlug}`
                            : social.name === 'Telegram'
                            ? `https://telegram.me/share/url?url=${baseURl}/${post.blogPostUrlSlug}&text=${post.title}`
                            : '/'
                        }
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                    >
                        {social.icon}
                    </a>
                </div>
            ))}
        </div>
    )
}